import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import InputMask from "react-input-mask";
import { Card, Form, Button, Alert } from "react-bootstrap";
import api from "../../../../Utils/api";

const CadastroUsuario = () => {
    const [userName, setUserName] = useState("");
    const [userEmail, setUserEmail] = useState("");
    const [userPassword, setUserPassword] = useState("");
    const [userContato, setUserContato] = useState("");
    const [userMatriculaId, setUserMatriculaId] = useState("");
    const [userGraduacao, setUserGraduacao] = useState("");
    const [userBarra, setUserBarra] = useState("");
    const [roles, setRoles] = useState([]);
    const [roleKey, setRoleKey] = useState("");
    const [erroMessagem, setErroMessagem] = useState("");
    const [erroShow, setErroShow] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        api.get("/access/roles")
            .then(({ data }) => {
                const activeRoles = (data.roles || []).filter((role) => role.active);
                setRoles(activeRoles);
                setRoleKey(activeRoles.some((role) => role.key === "basico")
                    ? "basico"
                    : activeRoles[0]?.key || "");
            })
            .catch((error) => {
                setErroShow(true);
                setErroMessagem(error.response?.data?.message || "Não foi possível carregar as roles disponíveis.");
            });
    }, []);

    function limpaCampos() {
        setUserName("");
        setUserEmail("");
        setUserPassword("");
        setUserContato("");
        setUserMatriculaId("");
        setUserGraduacao("");
        setUserBarra("");
        setRoleKey("basico");
    }

    async function handleRegistrar(e) {
        e.preventDefault();
        setErroShow(false);
        setErroMessagem("");

        api.post("/user", {
            userName,
            userEmail,
            userPassword,
            userContato,
            userMatriculaId,
            userGraduacao,
            userBarra,
            roleKey
        })
        .then(response => {
            alert(response.data.message);
            limpaCampos();
            navigate("/administrador/usuarios");
        })
        .catch(error => {
            console.error(error);
            setErroShow(true);
            setErroMessagem(error.response?.data?.message || "Erro ao registrar usuário.");
        });
    }

    return (
        <Card>
            <Card.Header className="text-center">
                <Card.Title>Registrar Usuário</Card.Title>
            </Card.Header>
            <Card.Body>
                {erroShow && <Alert variant="danger">{erroMessagem}</Alert>}

                <Form onSubmit={handleRegistrar}>
                    <Form.Label>Role:</Form.Label>
                    <Form.Select required value={roleKey} onChange={(e) => setRoleKey(e.target.value)}>
                        <option value="" disabled>Selecione uma role</option>
                        {roles.map((role) => (
                            <option key={role.key} value={role.key}>{role.name}</option>
                        ))}
                    </Form.Select>
                    <br />

                    <Form.Label>Usuário:</Form.Label>
                    <Form.Control
                        required
                        value={userName}
                        onChange={(e) => setUserName(e.target.value)}
                        placeholder="Nome"
                    />
                    <br />

                    <Form.Label>Matrícula ou ID:</Form.Label>
                    <InputMask
                        required
                        value={userMatriculaId}
                        className="form-control"
                        type="number"
                        onChange={(e) => setUserMatriculaId(e.target.value)}
                        placeholder="Matrícula ou ID"
                    />
                    <br />

                    <Form.Label>Graduação:</Form.Label>
                    <Form.Control
                        required
                        value={userGraduacao}
                        onChange={(e) => setUserGraduacao(e.target.value)}
                        placeholder="Ex.: Capitão"
                    />
                    <br />

                    <Form.Label>Número da Barra:</Form.Label>
                    <Form.Control
                        required
                        value={userBarra}
                        onChange={(e) => setUserBarra(e.target.value)}
                        placeholder="Ex.: 123/21"
                    />
                    <br />

                    <Form.Label>E-mail:</Form.Label>
                    <Form.Control
                        required
                        value={userEmail}
                        onChange={(e) => setUserEmail(e.target.value)}
                        placeholder="E-mail"
                    />
                    <br />

                    <Form.Label>Contato:</Form.Label>
                    <InputMask
                        required
                        value={userContato}
                        className="form-control"
                        mask="(99) 9 9999-9999"
                        onChange={(e) => setUserContato(e.target.value)}
                        placeholder="(99) 9 0000-0000"
                    />
                    <br />

                    <Form.Label>Senha:</Form.Label>
                    <Form.Control
                        required
                        value={userPassword}
                        onChange={(e) => setUserPassword(e.target.value)}
                        placeholder="Senha"
                        type="password"
                    />
                    <br />

                    <Button variant="success" type="submit">
                        Registrar
                    </Button>
                </Form>
            </Card.Body>
        </Card>
    );
};

export default CadastroUsuario;
